import React, { useCallback, useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import styled from 'styled-components';

import clsx from 'clsx';

import useSticky from '@ecp/common/src/hooks/useSticky';
import { zIndex } from '@ecp/common/src/style/constant';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { FlexBoxColumn, HorizontalDivider } from '@ecp/common/src/layouts/flex/styled';
import { MAIN_FUNCTION_TYPE_CODE } from '@ecp/common/src/const/display/mainTemplateConst';

import { commonMainFunctionListState } from '@fo-recoil/main/atom';
import mainFunctionApi from '@fo-apis/display/mainFunctionApi';
import AsianaGnbHeader from '@ecp/fo/sites/asiana/components/gnb/AsianaGnbHeader';

const AsianaGnb = () => {
  const { ref, sticky } = useSticky();
  const className = clsx({ sticky });

  const setCommonMainFunctionList = useSetRecoilState(commonMainFunctionListState);
  const fetchCommonMainFunctionList = useCallback(async () => {
    const { result } = await mainFunctionApi.getMainFunctionList(MAIN_FUNCTION_TYPE_CODE.COMMON);
    setCommonMainFunctionList(result);
  }, [setCommonMainFunctionList]);

  useEffect(() => {
    (async () => {
      try {
        await Promise.all([fetchCommonMainFunctionList()]);
      } catch (e) {
        console.error(e);
      }
    })();
  }, [fetchCommonMainFunctionList]);

  return (
    <Container className={className}>
      <GnbWrapper className={className}>
        <GnbHeaderContainer className={className}>
          {!sticky && <Spacing top={15} />}
          <AsianaGnbHeader ref={ref} searchPhraseList={null} />
          <HorizontalDivider width="calc(max(100vw, 1630px))" />
        </GnbHeaderContainer>
      </GnbWrapper>
    </Container>
  );
};

export default AsianaGnb;

const Container = styled.div`
  width: calc(max(100vw, 1630px));
  height: 25px;

  z-index: ${zIndex.appBar};

  &.sticky {
    height: 80px;
  }
`;

const GnbWrapper = styled.div`
  width: calc(max(100vw, 1630px));
  height: 100%;

  position: relative;
  background-color: #ffffff;

  &.sticky {
    height: 80px;

    position: fixed;
    top: 0;
  }
`;

const GnbHeaderContainer = styled(FlexBoxColumn)`
  width: 1540px;

  position: absolute;
  top: 0;
  left: calc(max(50% - 770px, 45px));

  background-color: ${(props) => props.theme.color.background.white};
  font-weight: ${(props) => props.theme.font.weight.demiLight};

  &.sticky {
    position: fixed;
    top: 0;
    height: 80px;
    padding: 15px 0 0;
    transition-duration: 0.2s;
  }
`;
